<ngx-doc-viewer
  [url]="resource.url"
  viewer="url" 
  style="width:100%;height:70vh;"
></ngx-doc-viewer>
